import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { makeStateKey, TransferState } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Client } from "@interfaces";
import { EMPTY, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ClientsService } from "./clients.service";

@Injectable({
    providedIn: "root",
})
export class SubdomainService {
    private subdomain = null;
    private subdomainClient: Client;
    private SINGLE_KEY = makeStateKey<Client>("subdomain-client");

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private clientService: ClientsService,
        private router: Router,
        private transferState: TransferState,
    ) {
        if (isPlatformBrowser(this.platformId)) {
            const url = window.location.hostname;
            if (url.includes(".")) {
                this.subdomain = url?.split(".")[0];
            }
        }
    }

    public getCurrentSlug(): string {
        return this.subdomain;
    }

    public setClientPreview(client: Client) {
        this.transferState.set(this.SINGLE_KEY, client);
    }

    public getClient(): Observable<Client> {
        let client: Client;
        if (this.transferState.hasKey(this.SINGLE_KEY)) {
            client = this.transferState.get<Client>(this.SINGLE_KEY, null);
            return of(client);
        } else {
            return (this.clientService.getOrg() as Observable<Client>).pipe(
                map((value: Client) => {
                    if (value) {
                        if (isPlatformServer(this.platformId)) {
                            this.transferState.set(this.SINGLE_KEY, value);
                        }
                        return value;
                    } else {
                        throw new HttpErrorResponse({
                            error: 'Client not found',
                            status: 404,
                        });
                    }
                }),
                catchError(this.handleError.bind(this))
            );
        }
    }

    public getUrlFromSlug(slug: string): string {
        if (this.subdomainClient?.alias) {
            return `https://${this.subdomainClient?.alias}`;
        } else {
            return environment.domain.replace("foo", slug);
        }
    }

    public getLogo() {
        return this.subdomainClient?.logo?.public_id;
    }

    public getClientId() {
        return this.subdomainClient?._id;
    }

    private handleError(e: HttpErrorResponse) {
        this.router.navigate(["/404"]);
        return EMPTY;
    }
}
